/**
 * 登陆页面配置
 */
const path = require('path');
const homeUrl = Config.homeUrl;
const registerUrl = Config.registerUrl;
const centerUrl = Config.centerUrl;
const retrievePwdUrl = Config.retrievePwdUrl;
const lbdpUrl = Config.lbdpUrl;
const protocalUrl = Config.protocalUrl;

/**
 * 匹配控制中心入口或者登陆入口
 * @param {String} urlString 
 */
export function matchUrl(urlString) {
    const localUrlConfig = {
        'center': 'center.html',
        'index': 'index.html',
        'register': 'register.html',
        'retrievePwd': 'retrievePwd.html',
        'protocal': 'protocal.html'
    }

    const onlineUrlConfig = {
        'center': centerUrl,
        'index': homeUrl,
        'register': registerUrl,
        'retrievePwd': retrievePwdUrl,
        'protocal': protocalUrl,
        'lbdp': lbdpUrl
    }


    // return process.env.NODE_ENV === 'development' ? path.resolve(__dirname, localUrlConfig[urlString]) : path.resolve(__dirname, `motor-center/build/${localUrlConfig[urlString]}`)
    return process.env.NODE_ENV === 'development' ? urlString === 'lbdp' ? 'http://localhost:1234/#/' : path.resolve(__dirname, localUrlConfig[urlString]) : onlineUrlConfig[urlString]
}

/**
 * 获取页面cookie
 * @param {String} name 
 */
export function getCookie(name) {
    var arr, reg= new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
　　return (arr = document.cookie.match(reg)) ? decodeURI(arr[2]) : null;
}

/**
 * 设置cookie
 * @param {String} key 
 * @param {String} value 
 * @param {String|Number} exdays 
 */
export function setCookie(key, value, exdays) {
    console.log('path=/')
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
    //字符串拼接cookie
    window.document.cookie = encodeURI(key) + "=" + encodeURI(value) + ";path=/;expires=" + exdate.toGMTString();
}

/**
 * 清楚cookie
 * @param {String} key 
 * @param {String} value 
 * @param {String|Number} exdays 
 */
export function clearCookie(key, value = '', exdays = -1) {
    console.log(setCookie)
    setCookie(key, value, exdays)
}

/**
 * 获取浏览器查询参数对象
 * @param {String} search 
 * @param {String} queryString 
 */
export function getQueryString(search, queryString) {
    var reg = new RegExp('(^|&)' + queryString + '=([^&]*)(&|$)', 'i');
    var arr = [];
    return (arr =search.substr(1).match(reg)) ? unescape(arr[2]) : null;
}

/**
 * 是否存在from字段
 * @param {Boolean} search 
 */
export function isContainFrom(search) {
    return search.indexOf('from') !== -1
}

/**
* encrypto 加密程序
* @param {Strng} str 待加密字符串
* @param {Number} xor 异或值
* @param {Number} hex 加密后的进制数
* @return {Strng} 加密后的字符串
*/
export function encrypto(str, xor, hex ) {
    if ( typeof str !== 'string' || typeof xor !== 'number' || typeof hex !== 'number') {
        return;
    }

    let resultList = []; 
    hex = hex <= 25 ? hex : hex % 25;

    for ( let i=0; i<str.length; i++ ) {
        // 提取字符串每个字符的ascll码
        let charCode = str.charCodeAt(i);
        // 进行异或加密
        charCode = (charCode * 1) ^ xor;
        // 异或加密后的字符转成 hex 位数的字符串
        charCode = charCode.toString(hex);
        resultList.push(charCode);
    }

    let splitStr = String.fromCharCode(hex + 97);
    let resultStr = resultList.join( splitStr );
    return resultStr;
}


/**
 * // TODO
 * 用户名校验规则
 * @param {String} userName 
 */
export function userNameReg(userName) {
    const name = userName;
    var charReg = /[^\u4E00-\u9FA5\w]/; // 判断是否有非法字符(除了中英文、数字、下划线以外的字符)
    var numReg = /\D/;//纯数字
    var charCodeReg =/^[\u4e00-\u9fa5]+$/;
    var len = 0;
    let msg = ''
    
    if (name.trim() === '') {
        return {msg: '用户名不能为空'}
    }

    if(charReg.test(name)) {
        return {msg:'用户名仅支持中英文、数字和下划线,且不能为纯数字'}
    }

    if(!numReg.test(name)) {
        return {msg: '用户名仅支持中英文、数字和下划线,且不能为纯数字'}
    }

    for (var i = 0; i < name.length; i++ ) {
        // 如果是中文，就+2；否则+1
        if (charCodeReg.test(name[i])) {
            len += 2;
        } else {
            len += 1;
        }
        
        // 尽量避免执行过多的次数，一旦len超过14就不满足条件了
        if (len > 14) {
            break;
        }
    }

    if(len > 14) {
        return {msg: '用户名不能超过7个汉字或14个字符'}
    } else {
        return false;
    }
}